module.exports = __webpack_public_path__ + "img/emoji events black 24dp.3aaffdc5.svg";